<template>
  <v-card
    v-if="getMenuShow"
    class="align-center justify-start rounded-lg pt-10"
    flat
    color="greyColor"
    height="190"
    width="190"
    :to="item.to"
  >
    <!-- <div style="width: 60px" class="px-4">
      <div style="width: 60px">
      <v-avatar width="90%" height="100%" tile class="rounded-lg" max-width="200" max-height="140">
        <v-img :src="item.icon" style="opacity: 0.8"></v-img>
      </v-avatar>
    </div> -->
    <v-card-title class="mx-4 pa-0" style="word-break: break-word; width: 60px">
      <v-avatar tile width="60" height="60">
        <v-img :src="require('@/../public/images/menu/' + item.icon).default" contain>
        </v-img>
      </v-avatar>
    </v-card-title>
    <v-card-title
      class="mx-4 pa-0 mt-3 defaultColor--text font-weight-medium"
      style="
        word-break: break-word;
        width: 150px;
        font-size: 14px;
        line-height: 20px;
      "
      v-text="item.title"
    ></v-card-title>

    <!-- <v-card-actions>
        <v-btn fab icon height="40px" right width="40px" :to="item.to">
          <v-icon>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-card-actions> -->
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    item: Object,
  },
  mounted() {},
  methods: {},
  computed: {
    getMenuShow() {
      if (this.$store.state.user.Type.toLowerCase() != "standart") {
        //Admin hepsini görür
        return true;
      } else if (this.$store.state.user.Type.toLowerCase() == "standart") {
        if (!this.item.isAdmin) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
